module.exports = __webpack_public_path__ + "img/F.Sc (Engineering).3aea16a9.svg";